/** DB enum values that may access the admin panel. */
export const ADMIN_PANEL_ROLES = ['superadmin', 'store_manager', 'picker', 'inventory_operator', 'finance'] as const;
/** Keep general operations separate from staff admission to the panel. */
export const STORE_OPERATIONS_ROLES = ['superadmin', 'store_manager'] as const;
export const FINANCE_ROLES = ['superadmin', 'finance'] as const;
export const PICKING_ROLES = ['superadmin', 'store_manager', 'picker'] as const;
export const COUNTING_ROLES = ['superadmin', 'store_manager', 'inventory_operator'] as const;
export type AdminPanelRole = (typeof ADMIN_PANEL_ROLES)[number];

export type AppUserRole =
  | 'superadmin'
  | 'store_manager'
  | 'picker'
  | 'inventory_operator'
  | 'finance'
  | 'rider'
  | 'user';

export const ROLE_LABELS: Record<AppUserRole, string> = {
  superadmin: 'Super Admin',
  store_manager: 'Store Manager',
  picker: 'Picker',
  inventory_operator: 'Inventory Operator',
  finance: 'Finance',
  rider: 'Rider',
  user: 'Customer',
};

export function isAdminPanelRole(role: string | null | undefined): boolean {
  return ADMIN_PANEL_ROLES.includes(role as AdminPanelRole);
}

/** Extra roles never promote an account to Manager or Super Admin. */
export function assignedStaffRoles(primary: string | null | undefined, additional: unknown = []): AdminPanelRole[] {
  if (!isAdminPanelRole(primary)) return [];
  const extras = Array.isArray(additional) ? additional : [];
  return [...new Set([primary as AdminPanelRole, ...extras.filter((role): role is AdminPanelRole =>
    role === 'picker' || role === 'inventory_operator' || role === 'finance')])];
}

export function roleLabel(role: string | null | undefined): string {
  if (!role) return 'Unknown';
  return ROLE_LABELS[role as AppUserRole] ?? role;
}

export function adminHome(role: string | null | undefined): string {
  switch (role) {
    case 'picker': return '/operations/picking';
    case 'inventory_operator': return '/inventory/receiving';
    case 'finance': return '/finance/reconciliation';
    case 'superadmin':
    case 'store_manager': return '/dashboard';
    default: return '/login';
  }
}
